import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType, Geofence, GeofencePointsType, GeoModelCommon } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'Property';

export type PropertyProps = {
  farmsOnLineIdentifier?: string;
  agriBaseFarm_id?: GeofencePointsType;
  ePCglobalSerialisedGlobalLocationNumber?: string;
  address?: string;
  created_by?: string;
  country?: string;
  updated_at?: number;
  created_at?: number;
  is_default?: boolean;
  points: GeofencePointsType[];
};

export class Property extends GeoModelCommon implements PropertyProps {
  constructor(ob: Partial<PropertyProps>) {
    super({ type: typeName, ...ob });
    this.points = ob.points ?? [];
  }

  farmsOnLineIdentifier?: string;
  agriBaseFarm_id?: GeofencePointsType;
  ePCglobalSerialisedGlobalLocationNumber?: string;
  address?: string;
  created_by?: string;
  updated_at?: number;
  created_at?: number;
  is_default?: boolean;
  points: GeofencePointsType[];

  //do we need?
  dwelling_number?: string;
  // street_number?: string;
  suburb?: string;
  city?: string;
  region?: string;
  country?: string;
  post_code?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of farm',
      },
      farmsOnLineIdentifier: {
        type: 'String',
        editable: true,
        label: 'FarmsOnLine identifier',
        name: 'farmsOnLineIdentifier',
        description: 'Ministry for Primary Industries FarmsOnLine identifier',
      },
      agriBaseFarm_id: {
        type: 'object',
        editable: true,
        label: 'AgriBase farm_id',
        name: 'agriBaseFarm_id',
        description: 'AgriBase farm_id (based on a coordinate pair in lat/long, NZTM or NZMG coordinates)',
      },
      ePCglobalSerialisedGlobalLocationNumber: {
        type: 'String',
        editable: true,
        label: 'EPCglobal Serialised Global Location Number',
        name: 'ePCglobalSerialisedGlobalLocationNumber',
        description:
          'EPCglobal Serialised Global Location Number2 (sGLN) (as used by the EPC Network Architecture). (The NZ Business Number is based on a GS1 GLN through a partnership with GS1 NZ)',
      },
      Waterway: {
        type: 'object',
        editable: true,
        label: 'Waterway',
        name: 'Waterway',
        description: 'Waterway of farm',
      },
      address: {
        type: 'String',
        editable: true,
        label: 'Address',
        name: 'address',
        description: 'Address of farm',
      },
      type: {
        type: 'String',
        editable: true,
        label: 'Type',
        name: 'type',
        description: 'Type of farm eg dairy, mixed, sheep',
      },
      boundary: {
        type: 'Number',
        editable: true,
        label: 'Location',
        name: 'location',
        description: 'External boundaries of farm',
      },
    };
  };
}
